/* TCcustoms Garage - vanilla JS, localStorage, no dependencies.
   Vehicle = { model: "F-150", year: 2022 } (make is Ford unless model says otherwise)
   Storage: tcc_garage_v1 = { vehicles: [...], active: 0 } */
(function () {
  'use strict';
  var KEY = 'tcc_garage_v1';

  function read() {
    try {
      var d = JSON.parse(localStorage.getItem(KEY));
      if (d && Array.isArray(d.vehicles)) return d;
    } catch (e) {}
    return { vehicles: [], active: -1 };
  }
  function write(d) {
    try { localStorage.setItem(KEY, JSON.stringify(d)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('tcc:garage', { detail: d }));
  }
  function active() {
    var d = read();
    return d.active >= 0 ? d.vehicles[d.active] || null : null;
  }
  function label(v) { return v ? (v.year ? v.year + ' Ford ' + v.model : 'Ford ' + v.model) : ''; }
  /* tokens use underscores for spaces so multi-word models stay one token ("bronco_sport") */
  function token(v, withYear) {
    if (!v) return '';
    var t = String(v.model).trim().toLowerCase().replace(/\s+/g, '_');
    return withYear && v.year ? t + ':' + v.year : t;
  }
  /* tag handle used in Shopify tag-filter URLs: "TCfit:F-150:2022" -> "tcfit-f-150-2022" */
  function tagHandle(v) {
    var raw = 'TCfit:' + v.model + (v.year ? ':' + v.year : '');
    return raw.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  var G = {
    get: read, getActive: active, label: label, tagHandle: tagHandle,
    save: function (v) {
      var d = read();
      var i = d.vehicles.findIndex(function (x) { return x.model === v.model && x.year === v.year; });
      if (i < 0) { d.vehicles.push(v); i = d.vehicles.length - 1; }
      d.active = i; write(d); render();
    },
    setActive: function (i) { var d = read(); if (d.vehicles[i]) { d.active = i; write(d); render(); } },
    remove: function (i) {
      var d = read(); d.vehicles.splice(i, 1);
      if (d.active >= d.vehicles.length) d.active = d.vehicles.length - 1;
      write(d); render();
    }
  };
  window.TCCGarage = G;

  /* ---------- fitment matching ----------
     el data-tcfit: space-separated tokens like "f-150 f-150:2015 f-150:2016 spec"
     verdict: fit (model:year match) | model (model matches, year unknown or vehicle has no year)
              | no (model present in data but not vehicle's) | spec | unknown (no data) */
  function verdictFor(el, v) {
    var data = (el.getAttribute('data-tcfit') || '').trim().toLowerCase();
    if (!data) return 'unknown';
    /* accept spaces or underscores in stored tokens, old or new format */
    var toks = data.split(/\s+/);
    if (!v) return 'none';
    var m = token(v, false), my = token(v, true);
    var mAlt = m.replace(/_/g, ' '), myAlt = my.replace(/_/g, ' ');
    if (v.year && (toks.indexOf(my) > -1 || data.indexOf(my) > -1 || data.indexOf(myAlt) > -1)) return 'fit';
    var hasModel = toks.indexOf(m) > -1 || data.indexOf(m + ':') > -1 || data.indexOf(mAlt + ':') > -1 ||
                   (' ' + data + ' ').indexOf(' ' + mAlt + ' ') > -1;
    var modelHasYears = data.indexOf(m + ':') > -1 || data.indexOf(mAlt + ':') > -1;
    if (hasModel && (!v.year || !modelHasYears)) return 'model';
    if (hasModel && v.year && modelHasYears) return 'no';
    if (toks.indexOf('spec') > -1) return 'spec';
    return 'no';
  }

  /* ---------- wheel fitment by bolt pattern ----------
     Verified July 2026 (manufacturer specs; note Bronco Raptor is 6x135, unlike base Bronco):
     6x135: F-150 2004+, F-150 Raptor (all), F-150 Raptor R, Expedition 2003+, Bronco Raptor
     6x139.7: Bronco 2021+, Ranger 2019+, Ranger Raptor
     5x108: Maverick, Bronco Sport | 5x114.3: Mustang 2005+ | 8x170: F-250/F-350 SRW */
  var BOLT_PATTERNS = {
    'f-150': '6x135', 'f-150_raptor': '6x135', 'f-150_raptor_r': '6x135',
    'expedition': '6x135', 'bronco_raptor': '6x135',
    'bronco': '6x139.7', 'ranger': '6x139.7', 'ranger_raptor': '6x139.7',
    'maverick': '5x108', 'bronco_sport': '5x108',
    'mustang': '5x114.3', 'f-250': '8x170', 'f-350': '8x170'
  };
  function boltFor(v) { return v ? BOLT_PATTERNS[token(v, false)] || null : null; }
  function boltHandle(v) { var b = boltFor(v); return b ? b.toLowerCase().replace(/[^a-z0-9]+/g, '-') : null; }
  function isWheelsUrl(u) { return String(u).indexOf('/collections/wheels') > -1; }

  function badgeHTML(kind, v) {
    var lbl = v ? label(v) : '';
    if (kind === 'fit') return '<span class="tcc-badge tcc-badge--fit">Fits your ' + esc(lbl) + '</span>';
    if (kind === 'model') return '<span class="tcc-badge tcc-badge--check">Check year fit for your ' + esc(v.model) + '</span>';
    if (kind === 'no') return '<span class="tcc-badge tcc-badge--no">May not fit your ' + esc(lbl) + '</span>';
    if (kind === 'spec') return '<span class="tcc-badge tcc-badge--check">Fits by size, verify with us</span>';
    return '';
  }
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  function annotateCards(root) {
    var v = active();
    (root || document).querySelectorAll('[data-tcc-badge]').forEach(function (slot) {
      var holder = slot.closest('[data-tcfit]') || slot;
      var kind = verdictFor(holder, v);
      slot.innerHTML = (kind === 'none' || kind === 'unknown') ? '' : badgeHTML(kind, v);
    });
  }

  /* ---------- PDP verdict block ---------- */
  function renderVerdict() {
    var box = document.querySelector('[data-tcc-verdict]');
    if (!box) return;
    var v = active();
    var kind = verdictFor(box, v);
    var head = box.querySelector('[data-tcc-verdict-head]');
    if (!head) return;
    box.classList.remove('tcc-verdict--fit', 'tcc-verdict--no', 'tcc-verdict--check');
    if (!v) {
      head.innerHTML = 'Will it fit your truck? <button type="button" class="tcc-link" data-tcc-open-garage>Select your vehicle</button>';
      box.classList.add('tcc-verdict--check');
    } else if (kind === 'fit') {
      head.innerHTML = 'Yes. This fits your ' + esc(label(v)) + '.';
      box.classList.add('tcc-verdict--fit');
    } else if (kind === 'no') {
      head.innerHTML = 'This does not list your ' + esc(label(v)) + '.';
      box.classList.add('tcc-verdict--no');
    } else if (kind === 'model') {
      head.innerHTML = 'Made for the ' + esc(v.model) + '. Confirm your ' + (v.year || 'model year') + ' with us.';
      box.classList.add('tcc-verdict--check');
    } else if (kind === 'spec') {
      var pb = (box.getAttribute('data-tcc-bolt') || '').toLowerCase();
      var vb = boltFor(v), vbh = boltHandle(v);
      if (pb && vb) {
        if (pb.split(/\s+/).indexOf(vbh) > -1) {
          head.innerHTML = 'Bolt pattern matches your ' + esc(label(v)) + ' (' + esc(vb) + '). Verify size and offset below.';
          box.classList.add('tcc-verdict--fit');
        } else {
          head.innerHTML = 'This bolt pattern does not match your ' + esc(label(v)) + ' (' + esc(vb) + ').';
          box.classList.add('tcc-verdict--no');
        }
      } else {
        head.innerHTML = 'This one fits by size, not by model. Check the specs below.';
        box.classList.add('tcc-verdict--check');
      }
    } else {
      head.innerHTML = 'Fitment not confirmed yet for your ' + esc(label(v)) + '.';
      box.classList.add('tcc-verdict--check');
    }
  }

  /* ---------- garage bar + fit links ---------- */
  function render() {
    var v = active();
    document.querySelectorAll('[data-tcc-garage-label]').forEach(function (el) {
      el.innerHTML = v ? 'Shopping for: <em>' + esc(label(v)) + '</em>' : 'Find parts that fit my truck';
    });
    document.querySelectorAll('[data-tcc-garage-cta]').forEach(function (el) {
      el.textContent = v ? 'Change' : 'Select my truck';
    });
    /* collection "fits my truck" links: base collection URL + /<tagHandle>.
       Wheels are matched by BOLT PATTERN, not model tags. */
    document.querySelectorAll('[data-tcc-fitlink]').forEach(function (a) {
      var base = a.getAttribute('data-base') || '';
      if (v) {
        var t = a.querySelector('[data-fitlink-label]');
        if (isWheelsUrl(base) && boltFor(v)) {
          a.href = base.replace(/\/$/, '') + '/bolt-pattern-' + boltHandle(v);
          if (t) t.textContent = 'Show wheels that fit my ' + label(v) + ' (' + boltFor(v) + ')';
        } else {
          a.href = base.replace(/\/$/, '') + '/' + tagHandle(v) + '?fitby=' + encodeURIComponent(token(v, true));
          if (t) t.textContent = 'Show parts that fit my ' + label(v);
        }
        a.hidden = false;
      } else { a.hidden = true; }
    });
    /* my-truck hub links: base collection URL, plus the fitment tag when a truck is set */
    document.querySelectorAll('[data-tcc-hub-link]').forEach(function (a) {
      var base = a.getAttribute('data-base') || '/collections/all';
      if (v && isWheelsUrl(base) && boltFor(v)) {
        a.href = base.replace(/\/$/, '') + '/bolt-pattern-' + boltHandle(v);
      } else {
        a.href = v ? base.replace(/\/$/, '') + '/' + tagHandle(v) : base;
      }
    });
    /* hub tiles: hide categories that do not apply to the selected model */
    document.querySelectorAll('[data-tcc-hub-tile]').forEach(function (tile) {
      var list = (tile.getAttribute('data-models') || '').trim();
      if (!v || !list) { tile.hidden = false; return; }
      tile.hidden = list.toLowerCase().indexOf(v.model.toLowerCase()) === -1;
    });
    /* vehicle fields in forms */
    document.querySelectorAll('[data-tcc-vehicle-field]').forEach(function (inp) {
      if (v && !inp.value) inp.value = label(v);
    });
    annotateCards(document);
    renderVerdict();
    var drawer = document.querySelector('[data-tcc-drawer]');
    if (drawer) renderSaved(drawer);
  }

  /* ---------- drawer ---------- */
  var pending = { model: null, year: null };
  function openDrawer() {
    var d = document.querySelector('[data-tcc-drawer]');
    if (!d) return;
    d.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    var first = d.querySelector('.tcc-modelgrid__btn');
    if (first) first.focus();
  }
  function closeDrawer() {
    var d = document.querySelector('[data-tcc-drawer]');
    if (!d) return;
    d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }
  function renderSaved(drawer) {
    var host = drawer.querySelector('[data-tcc-saved]');
    if (!host) return;
    var d = read();
    if (!d.vehicles.length) { host.innerHTML = ''; return; }
    var html = '<p class="tcc-drawer__steplabel">My garage</p>';
    d.vehicles.forEach(function (v, i) {
      html += '<div class="tcc-drawer__savedrow"><span>' + (i === d.active ? '&#10003; ' : '') + esc(label(v)) + '</span><span>' +
        (i === d.active ? '' : '<button type="button" data-tcc-use="' + i + '">Use</button>') +
        '<button type="button" class="tcc-remove" data-tcc-del="' + i + '">Remove</button></span></div>';
    });
    host.innerHTML = html;
  }
  /* model-year availability: [firstYear, lastYear] spans per model; default 1997-2027 */
  var MODEL_YEARS = {
    'F-150 Raptor': [[2010, 2014], [2017, 2020], [2021, 2027]],
    'F-150 Raptor R': [[2023, 2027]],
    'Bronco Raptor': [[2022, 2027]],
    'Ranger Raptor': [[2024, 2027]],
    'Bronco': [[2021, 2027]],
    'Bronco Sport': [[2021, 2027]],
    'Maverick': [[2022, 2027]]
  };
  function yearAllowed(model, y) {
    var spans = MODEL_YEARS[model];
    if (!spans) return true;
    return spans.some(function (s) { return y >= s[0] && y <= s[1]; });
  }
  function buildYears(drawer, model) {
    var host = drawer.querySelector('[data-tcc-years]');
    if (!host) return;
    var key = model || '';
    if (host.getAttribute('data-built-for') === key && host.childElementCount) return;
    var now = 2027, html = '';
    for (var y = now; y >= 1997; y--) {
      if (model && !yearAllowed(model, y)) continue;
      html += '<button type="button" class="tcc-year" aria-pressed="false" data-tcc-year="' + y + '">' + y + '</button>';
    }
    host.innerHTML = html;
    host.setAttribute('data-built-for', key);
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null;
    if (!t) return;
    var open = t.closest('[data-tcc-open-garage]');
    if (open) { e.preventDefault(); openDrawer(); return; }
    if (t.closest('[data-tcc-close-garage]') || (t.classList && t.classList.contains('tcc-drawer__scrim'))) { closeDrawer(); return; }
    var mb = t.closest('[data-tcc-model]');
    if (mb && t.closest('[data-tcc-drawer]')) {
      e.preventDefault();
      pending.model = mb.getAttribute('data-tcc-model');
      mb.closest('.tcc-modelgrid').querySelectorAll('[aria-pressed]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      mb.setAttribute('aria-pressed', 'true');
      if (pending.year && !yearAllowed(pending.model, pending.year)) pending.year = null;
      buildYears(t.closest('[data-tcc-drawer]'), pending.model);
      return;
    }
    var yb = t.closest('[data-tcc-year]');
    if (yb) {
      pending.year = parseInt(yb.getAttribute('data-tcc-year'), 10);
      yb.closest('[data-tcc-years]').querySelectorAll('[aria-pressed]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
      yb.setAttribute('aria-pressed', 'true');
      return;
    }
    var save = t.closest('[data-tcc-save-garage]');
    if (save) {
      if (pending.model) {
        G.save({ model: pending.model, year: pending.year || null });
        closeDrawer();
        if (location.pathname.indexOf('/pages/shop-for-my-truck') === -1) {
          location.href = '/pages/shop-for-my-truck';
        }
      }
      return;
    }
    var use = t.closest('[data-tcc-use]');
    if (use) { G.setActive(parseInt(use.getAttribute('data-tcc-use'), 10)); return; }
    var del = t.closest('[data-tcc-del]');
    if (del) { G.remove(parseInt(del.getAttribute('data-tcc-del'), 10)); return; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- YouTube facades ---------- */
  document.addEventListener('click', function (e) {
    var f = e.target.closest && e.target.closest('[data-tcc-yt]');
    if (!f) return;
    var id = f.getAttribute('data-tcc-yt');
    f.innerHTML = '<iframe src="https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0" title="YouTube video" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen loading="lazy"></iframe>';
  });

  /* ---------- sticky buy bar ---------- */
  function initBuybar() {
    var bar = document.querySelector('[data-tcc-buybar]');
    var anchor = document.querySelector('[data-tcc-atc-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(anchor);
    var btn = bar.querySelector('[data-tcc-buybar-atc]');
    if (btn) btn.addEventListener('click', function () {
      var real = document.querySelector('[data-tcc-atc-anchor] [type="submit"], form[action*="/cart/add"] [type="submit"]');
      if (real) real.click();
    });
  }

  /* ---------- qty steppers ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tcc-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    var val = Math.max(1, (parseInt(input.value, 10) || 1) + (b.getAttribute('data-tcc-qty') === '+' ? 1 : -1));
    input.value = val;
  });

  /* ---------- install option wiring ---------- */
  function initInstall() {
    var chk = document.querySelector('[data-tcc-install-chk]');
    var loc = document.querySelector('[data-tcc-install-loc]');
    if (!chk) return;
    function sync() {
      if (loc) loc.hidden = !chk.checked;
      var propI = document.querySelector('input[name="properties[Professional Install]"]');
      if (propI) propI.disabled = !chk.checked;
      var propL = document.querySelector('input[name="properties[Install Location]"]');
      if (propL) { propL.disabled = !chk.checked; if (loc) propL.value = loc.querySelector('select') ? loc.querySelector('select').value : ''; }
    }
    chk.addEventListener('change', sync);
    if (loc) loc.addEventListener('change', sync);
    sync();
  }

  /* ---------- gallery filters ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tcc-gal-filter]');
    if (!b) return;
    var val = b.getAttribute('data-tcc-gal-filter');
    b.closest('.tcc-galfilters').querySelectorAll('button').forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    document.querySelectorAll('.tcc-gal figure').forEach(function (f) {
      var m = (f.getAttribute('data-models') || '').toLowerCase();
      f.classList.toggle('is-hidden', val !== 'all' && m.indexOf(val.toLowerCase()) === -1);
    });
  });

  function boot() {
    var drawer = document.querySelector('[data-tcc-drawer]');
    if (drawer) {
      /* Escape the sticky header wrapper: a position:fixed drawer inside a transformed
         ancestor gets trapped and clipped, which makes the open buttons look dead. */
      if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
      buildYears(drawer); renderSaved(drawer);
    }
    /* Direct bindings as well as delegation, in case other scripts stop propagation. */
    document.querySelectorAll('[data-tcc-open-garage]').forEach(function (b) {
      b.addEventListener('click', function (ev) { ev.preventDefault(); openDrawer(); });
    });
    /* Hub page: honor ?model= from quick links */
    if (location.pathname.indexOf('/pages/shop-for-my-truck') > -1) {
      var m = new URLSearchParams(location.search).get('model');
      var v = active();
      if (m && (!v || v.model !== m)) G.save({ model: m, year: null });
    }
    render(); initBuybar(); initInstall();
    /* Safety net: Shopify redirects unknown tag filters back to the unfiltered collection.
       When a fits-my-truck link was clicked (?fitby=), hide cards that do not match. */
    var fitby = new URLSearchParams(location.search).get('fitby');
    if (fitby) {
      var vv = active();
      var kept = 0;
      document.querySelectorAll('.tcc-card[data-tcfit]').forEach(function (c) {
        var kind = verdictFor(c, vv);
        if (kind === 'no' || kind === 'unknown') { c.style.display = 'none'; } else { kept++; }
      });
      var count = document.querySelector('.tcc-toolbar__count');
      if (count && vv) count.textContent = kept + ' shown for your ' + label(vv) + ' (on this page)';
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
